import { Tooltip } from 'antd';
import React, { Fragment } from 'react';
import H3Text from '@Uilib/h3Text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleExclamation,
  faClock, faIndustry, faPlugCircleXmark, faPowerOff, faUser,
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

const ListScreenKeys = ({ documentData, machineStatus }) => {
  const record = documentData;

  const finishedGood = () => {
    const productName = `#${record?.internal_sku_code} ${record?.product_sku_name}`;
    return (
      <div style={{
        textAlign: 'left',
        minWidth: '150px',
      }}
      >
        <Tooltip title={productName}>
          <a>
            {`${productName?.length > 20 ? `${productName?.substring(0, 20)}...` : productName}`}
          </a>
        </Tooltip>
        {record?.mo_adjustment_id && <H3Text text={`#${record?.fg_adjustment?.custom_batch_number}`} className="job-works__table-subtext" />}
        <div className="job-works__table-subtext">
          {record?.process_name}
        </div>
        <div className="job-works__table-subtext">
          {`${record?.target_quantity} ${record?.fg_uom_info?.uqc ? record?.fg_uom_info?.uqc?.toProperCase() : record?.sfg_uom_info?.uqc?.toProperCase()}`}
        </div>
      </div>
    );
  };

  const machine = () => (
    <div style={{
      textAlign: 'left',
      minWidth: '150px',
    }}
    >
      {
        !record?.machine_resource_group && record?.seller_info ? (
          <Fragment>
            <div style={{ color: '#333333', fontWeight: '500', marginBottom: '5px' }}>
              <FontAwesomeIcon icon={faUser} />
              &nbsp;
              <span>Subcontractor</span>
            </div>
            <div>
              {record?.seller_info ? `${record?.seller_info?.internal_slr_code} - ${record?.seller_info?.seller_name}` : ''}
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {
              record?.machine_resource_group ? (
                <Fragment>
                  <div style={{ color: '#333333', fontWeight: '500', marginBottom: '5px' }}>
                    <FontAwesomeIcon icon={faIndustry} />
                    &nbsp;
                    <span>{record?.machine_resource_group?.resource_group_name}</span>
                  </div>
                  <span
                    className="resource-status__icon"
                    style={{
                      color: (['ONLINE'].includes(record?.machine_resource_group?.allocated_machine?.status) && record?.machine_resource_group?.allocated_machine?.occupancy_status === 'IN_USE') ? '#EE404C' : machineStatus(record?.machine_resource_group?.allocated_machine?.status)?.color,
                      marginRight: '5px',
                    }}
                  >
                    {['OFFLINE'].includes(record?.machine_resource_group?.allocated_machine?.status)
                      && <FontAwesomeIcon icon={faPowerOff} />}
                    <Tooltip title="This machine is Online and available for use">
                      {['ONLINE'].includes(record?.machine_resource_group?.allocated_machine?.status) && record?.machine_resource_group?.allocated_machine?.occupancy_status === 'FREE'
                        && <FontAwesomeIcon icon={faPowerOff} />}
                    </Tooltip>
                    <Tooltip title="This machine currently in use">
                      {['ONLINE'].includes(record?.machine_resource_group?.allocated_machine?.status) && record?.machine_resource_group?.allocated_machine?.occupancy_status === 'IN_USE'
                        && <FontAwesomeIcon icon={faClock} />}
                    </Tooltip>
                    {['BREAKDOWN'].includes(record?.machine_resource_group?.allocated_machine?.status) && <FontAwesomeIcon icon={faPlugCircleXmark} />}
                  </span>
                  {record?.machine_resource_group?.allocated_machine ? `#${record?.machine_resource_group?.allocated_machine?.resource_number} - ${record?.machine_resource_group?.allocated_machine?.resource_name}` : ''}

                </Fragment>
              ) : '-'
            }
          </Fragment>
        )
      }
    </div>
  );

  const dependentJobCards = () => (
    <div style={{
      textAlign: 'left',
      minWidth: '150px',
    }}
    >
      {record?.incomplete_previous_job_works?.length ? (
        <div className={record?.incomplete_previous_job_works?.length ? 'job-work__warning-column' : ''}>
          {
          record?.incomplete_previous_job_works?.map((item) => (
            <span key={item?.jw_number}>
              <FontAwesomeIcon icon={faCircleExclamation} style={{ color: '#EE404C' }} />
              <span style={{ marginLeft: '2px' }}>{item?.jw_number}</span>
              &nbsp;
              <span>
                <H3Text text={item?.status?.toProperCase()?.replaceAll('_', ' ')} className="job-work__warning-column-status" />
              </span>
            </span>
          ))
          }
        </div>
      ) : '-'}
      {
        record?.rm_lines?.filter((item) => item?.issued_rm_qty === 0)?.length > 0 && (
          <div style={{ marginTop: '3px' }}>
            <H3Text text={`${record?.rm_lines?.filter((item) => item?.issued_rm_qty === 0)?.length} RM Not Issued`} className="job-work__warning-column-status" />
          </div>
        )
      }
    </div>
  );

  return [
    {
      label: 'Created Date',
      value: (
        <div style={{
          textAlign: 'left',
          minWidth: '150px',
        }}
        >
          {dayjs(record?.created_at).format('DD/MM/YYYY')}
          <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : '')} className="table-subscript" />
        </div>
      ),
    },
    {
      label: 'Finished Good',
      value: finishedGood(),
    },
    {
      label: 'Machine',
      value: machine(),
    },
    {
      label: 'Dependent Job Cards',
      value: dependentJobCards(),
    },
  ];
};

export default ListScreenKeys;
